const fetchConfig = {
  method: 'GET', // Метод запроса (GET, POST, PUT, DELETE и т.д.)
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 60000,
}

const api = {
  async get (path) {
    const response = await fetch(path, fetchConfig)
    return response.json()
  },

  async post (path, params) {
    const config = {
      ...fetchConfig,
      method: 'POST',
      body: JSON.stringify(params),
    }
    const response = await fetch(path, config)
    return response.json()
  },

  async put (path, params) {
    const config = {
      ...fetchConfig,
      method: 'PUT',
      body: JSON.stringify(params),
    }
    const response = await fetch(path, config)
    return response.json()
  },

  async delete (path) {
    const config = {
      ...fetchConfig,
      method: 'DELETE',
    }
    const response = await fetch(path, config)
    return response.json()
  },
}

export default api
